import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 cloud_opt_process cloud_cost_process"
      style={{ backgroundColor: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} className="m-auto text-center">
            <h3 className="h3_head">
              Our Cloud Cost <span>Optimization Process</span>
            </h3>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">01</div>
              <div className="rapid_content">
                <h5>
                  Analyze Cloud <br />
                  Usage
                </h5>
                <p>
                  Conduct a comprehensive assessment of your cloud consumption
                  to identify inefficiencies and areas for cost reduction.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">02</div>
              <div className="rapid_content">
                <h5>
                  Consultancy for Cost
                  <br /> Optimization
                </h5>
                <p>
                  Provide expert recommendations tailored to streamline your
                  cloud operations and minimize expenses.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="rapid_box">
              <div className="rapid_num">03</div>
              <div className="rapid_content">
                <h5>
                  Deploy Strategy & Optimize
                  <br /> Performance
                </h5>
                <p>
                  Implement a customized strategy to enhance cloud performance
                  while ensuring ongoing cost efficiency.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
